import { ArrowBack } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "jalali-moment";
import {
  addOneEquipment,
  getListEquipment,
  updateEquipment,
} from "../../../api/group";
import CustomizedHook from "../../project/autocomplatePro";
import { InputCreateProject } from "../../project/createProjectPop";
import DatePicker from "../../project/datePicker";
import Uploader from "../drug/uploader";
import TableEquipment from "./tableEquipment";

export default function NewEquipment({
  mode,
  setMode,
  equipmentIdFromUpdate,
  dataTableAll,
  setDataTableAll,
}) {
  const [dataTable, setDataTable] = useState([]);
  const [dataTimeUpdate, setDataTimeUpdate] = useState();
  // var dataTable = [];
  const [showDatePicker, setShowDatePicker] = useState();
  const [showDatePicker1, setShowDatePicker1] = useState();
  const [selectType, setSelectType] = useState(0);
  const [selectTypeMode, setSelectTypeMode] = useState(0);
  const [date, setDate] = useState();
  const [date1, setDate1] = useState();
  const [drugType, setDrugType] = useState([]);
  const [dataForm, setDataForm] = useState({
    equipmentType: selectTypeMode === 0 ? "CONSUMPTION" : "INFRASTRUCTURE",
    name: "",
    producer: "",
    available: 0,
    buyAt: "",
    usedAt: "",
    // guaranteeExpireAt: "",
    healthStatus: "VALID",
    rowNo: "",
    shelfNo: "",
    location: "",
    description: "",
    // propertyId: "",
  });

  useEffect(() => {
    if (selectTypeMode === 0) {
      setDataForm({
        equipmentType: "CONSUMPTION",
        name: "",
        producer: "",
        available: 0,
        buyAt: "",
        usedAt: "",
        // guaranteeExpireAt: "",
        healthStatus: "VALID",
        rowNo: "",
        shelfNo: "",
        location: "",
        description: "",
        // propertyId: "",);
      });
    }
    if (selectTypeMode === 1) {
      setDataForm({
        equipmentType: "INFRASTRUCTURE",
        name: "",
        producer: "",
        available: 0,
        buyAt: "",
        // usedAt: "",
        guaranteeExpireAt: "",
        healthStatus: "VALID",
        rowNo: "",
        shelfNo: "",
        location: "",
        description: "",
        propertyId: "",
      });
    }
  }, [selectTypeMode]);
  useEffect(() => {
    //  if(date){
    if (date && !dataTimeUpdate) {
      setDataForm({ ...dataForm, buyAt: date?.toUnix() * 1000 });
      // }
    }
    if (date && dataTimeUpdate) {
      const timestamp = moment
        .from(`${date.year}/${date.month}/${date.day}`, "fa", "YYYY/MM/DD")
        .valueOf();
      setDataForm({ ...dataForm, buyAt: timestamp });
      // console.log(date[0]);
      // }
    }
  }, [date]);
  useEffect(() => {
    //  if(date){
    if (date1 && !dataTimeUpdate) {
      if (dataForm?.equipmentType === "CONSUMPTION") {
        setDataForm({ ...dataForm, usedAt: date1?.toUnix() * 1000 });
      } else {
        setDataForm({ ...dataForm, guaranteeExpireAt: date1?.toUnix() * 1000 });
      }
      // }
    }
    if (date1 && dataTimeUpdate) {
      const timestamp = moment
        .from(`${date1.year}/${date1.month}/${date1.day}`, "fa", "YYYY/MM/DD")
        .valueOf();
      if (dataForm?.equipmentType === "CONSUMPTION") {
        setDataForm({ ...dataForm, usedAt: timestamp });
      } else {
        setDataForm({ ...dataForm, guaranteeExpireAt: timestamp });
      }
      // }
    }
  }, [date1]);

  useEffect(() => {
    if (equipmentIdFromUpdate) {
      setDataForm(equipmentIdFromUpdate);
      setDataTimeUpdate(true);
    }

    console.log(equipmentIdFromUpdate);
  }, [equipmentIdFromUpdate]);
  useEffect(() => {
    if (equipmentIdFromUpdate) {
      const datePart = dataForm.buyAt?.split(" - ")[0];

      // تجزیه سال، ماه و روز
      const [year, month, day] = datePart.split("/");

      // ساختن آرایه‌ای با دو آبجکت
      const dateDef = [
        { year: year, month: month, day: day },
        // { year: yearEnd, month: monthEnd, day: dayEnd },
      ];

      if (dataForm.usedAt?.length > 0) {
        const datePartEnd = dataForm.usedAt?.split(" - ")[0];
        const [yearEnd, monthEnd, dayEnd] = datePartEnd.split("/");
        const dateDef = [
          { year: year, month: month, day: day },
          { year: yearEnd, month: monthEnd, day: dayEnd },
        ];
        setDate(dateDef[0]);
        setDate1(dateDef[1]);
      }
      if (dataForm.guaranteeExpireAt?.length > 0) {
        const datePartEnd = dataForm.guaranteeExpireAt?.split(" - ")[0];
        const [yearEnd, monthEnd, dayEnd] = datePartEnd.split("/");
        const dateDef = [
          { year: year, month: month, day: day },
          { year: yearEnd, month: monthEnd, day: dayEnd },
        ];
        setDate(dateDef[0]);
        setDate1(dateDef[1]);
      }
      setDate(dateDef[0]);
      // console.log(dateDef[0]);

      // setDate1(dateDef[1]);
    }
  }, [dataTimeUpdate]);
  console.log(date);

  return (
    <Box mt="30px">
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
        notRange
      />
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date1}
        setDate={setDate1}
        show={showDatePicker1}
        setShow={setShowDatePicker1}
        notRange
      />
      <Box
        display={"flex"}
        alignItems="center"
        justifyContent={"space-between"}
      >
        <Typography mb="20px" className="title_GroupOnline">
          {"تجهیزات جدید"}
        </Typography>
        <Box
          sx={{
            cursor: "pointer",
            color: "var(--emr-darkblue)",
          }}
          onClick={() => {
            setMode("table");
          }}
        >
          <ArrowBack />
        </Box>
      </Box>
      <Box
        borderRadius="10px"
        bgcolor={"white"}
        width={"fit-content"}
        p="5px"
        display={"flex"}
        gap="3px"
        sx={{ cursor: "pointer" }}
      >
        <Box
          borderRadius="0px 10px 10px 0px"
          bgcolor={selectType === 0 ? "#125383" : "white"}
          p="5px 10px"
          color={selectType === 0 ? "white" : "black"}
          sx={{ transition: "0.3s all" }}
          onClick={() => setSelectType(0)}
        >
          افزودن تکی
        </Box>
        <Box
          borderRadius="10px 0px 0px 10px"
          bgcolor={selectType === 1 ? "#125383" : "white"}
          p="5px 10px"
          color={selectType === 1 ? "white" : "black"}
          sx={{ transition: "0.3s all" }}
          onClick={() => setSelectType(1)}
        >
          افزودن گروهی
        </Box>
      </Box>

      {selectType === 0 && (
        <Box
          mt="20px"
          border="solid 2px #6C8C97 "
          borderRadius={"13px"}
          width={"calc( 100% - 40px )"}
          // height="200px"
          p="40px 20px"
        >
          <Box
            borderRadius="10px"
            bgcolor={"white"}
            width={"fit-content"}
            p="5px"
            display={"flex"}
            gap="3px"
            sx={{ cursor: "pointer" }}
          >
            <Box
              borderRadius="0px 10px 10px 0px"
              bgcolor={
                dataForm?.equipmentType === "CONSUMPTION" ? "#125383" : "white"
              }
              p="5px 10px"
              color={
                dataForm?.equipmentType === "CONSUMPTION" ? "white" : "black"
              }
              sx={{ transition: "0.3s all" }}
              onClick={() => setSelectTypeMode(0)}
            >
              مصرفی
            </Box>
            <Box
              borderRadius="10px 0px 0px 10px"
              bgcolor={
                dataForm?.equipmentType === "INFRASTRUCTURE"
                  ? "#125383"
                  : "white"
              }
              p="5px 10px"
              color={
                dataForm?.equipmentType === "INFRASTRUCTURE" ? "white" : "black"
              }
              sx={{ transition: "0.3s all" }}
              onClick={() => setSelectTypeMode(1)}
            >
              زیرساختی
            </Box>
          </Box>
          {dataForm?.equipmentType === "CONSUMPTION" && (
            <>
              <Box display={"flex"} mt="40px" flexWrap="wrap" gap="10px">
                <InputCreateProject
                  placeholder={"نام دارایی را وارد کنید"}
                  label="نام دارایی"
                  value={dataForm?.name}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, name: e.target.value })
                  }
                />
                <InputCreateProject
                  placeholder={"شرکت سازنده تجهیزات را وارد کنید"}
                  label="شرکت سازنده"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, producer: e.target.value })
                  }
                  value={dataForm?.producer || ""}
                />
                <InputCreateProject
                  placeholder={"تعداد تجیهزات را وارد کنید"}
                  label="تعداد تجهیزات"
                  onChange={(e) =>
                    setDataForm({
                      ...dataForm,
                      available: Number(e.target.value),
                    })
                  }
                  value={dataForm?.available || ""}
                  type="number"
                />
                <InputCreateProject
                  placeholder={"زمان خرید را وارد کنید"}
                  label="زمان خرید"
                  onClick={(e) => {
                    setShowDatePicker(e.currentTarget);
                  }}
                  value={date ? `${date.year}/${date.month}/${date.day} ` : ""}
                  //   onChange={(e) => setTripName(e.target.value)}
                />
                <InputCreateProject
                  placeholder={"تاریخ مصرف را وارد کنید."}
                  label="تاریخ مصرف"
                  onClick={(e) => {
                    setShowDatePicker1(e.currentTarget);
                  }}
                  value={
                    date1 ? `${date1.year}/${date1.month}/${date1.day} ` : ""
                  }
                />

                <Box width={"250px"}>
                  <CustomizedHook
                    multiple
                    placeholder={"وضعیت را وارد کنید"}
                    label="وضعیت"
                    value={
                      [
                        { value: "سالم", key: "VALID" },
                        { value: "خراب", key: "DAMAGED" },
                        { value: "درحال تعمیر", key: "FIXING" },
                      ].find((w) => w.key === dataForm?.healthStatus) || null
                    }
                    options={[
                      { value: "سالم", key: "VALID" },
                      { value: "خراب", key: "DAMAGED" },
                      { value: "درحال تعمیر", key: "FIXING" },
                    ]}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setDataForm({
                          ...dataForm,
                          healthStatus: newValue.key,
                        });
                      }
                    }}
                  />
                </Box>

                <InputCreateProject
                  placeholder={"شماره ردیف را وارد کنید"}
                  label="شماره ردیف"
                  onChange={(e) =>
                    setDataForm({
                      ...dataForm,
                      rowNo: e.target.value,
                    })
                  }
                  value={dataForm?.rowNo || ""}
                  type="number"
                />
                <InputCreateProject
                  placeholder={"شماره قفسه تجهیزات را وارد کنید"}
                  label="شماره قفسه"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, shelfNo: e.target.value })
                  }
                  value={dataForm?.shelfNo || ""}
                />
                <InputCreateProject
                  placeholder={"محل انبار را وارد کنید"}
                  label="محل انبار"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, location: e.target.value })
                  }
                  value={dataForm?.location || ""}
                  //   type="number"
                />
                <InputCreateProject
                  placeholder={"توضیحات را وارد کنید"}
                  label="توضیحات"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, description: e.target.value })
                  }
                  value={dataForm?.description || ""}
                />
              </Box>
              <Box mt="20px" gap="10px" display={"flex"}>
                <button
                  style={{
                    border: "none",
                    color: "white",
                    background: "#125383",
                    width: "100px",
                    padding: "10px 0px",
                    borderRadius: "10px",
                  }}
                  onClick={() => {
                    // dataTable.push("mmd");
                    setDataTable([dataForm]);
                    // setDataForm({
                    //   name: "",
                    //   producer: "",
                    //   expireAt: "",
                    //   location: "SMALL",
                    //   drugType: "TAB",
                    //   available: "",
                    //   availablePack: "",
                    //   price: "",
                    //   shelfNo: "",
                    //   boxNo: "",
                    //   dose: "",
                    // });
                  }}
                >
                  ذخیره تجهیز
                </button>
                <button
                  style={{
                    border: "none",
                    color: "white",
                    background: "#126E83",
                    width: "100px",
                    padding: "10px 0px",
                    borderRadius: "10px",
                  }}
                  onClick={() => {
                    if (dataTable.length === 1) {
                      if (equipmentIdFromUpdate) {
                        updateEquipment(dataTable[0]?.id, dataTable[0])
                          .then(() => {
                            setMode("table");
                          })
                          .catch(() => {});
                      } else {
                        addOneEquipment(dataTable[0])
                          .then(() => {
                            setMode("table");
                          })
                          .catch(() => {});
                      }
                    }
                  }}
                >
                  ثبت تجهیز
                </button>
              </Box>
              <Box mt="30px">
                {dataTable?.length > 0 && (
                  <TableEquipment create date={date} rowData={dataTable} />
                )}
              </Box>
            </>
          )}
          {dataForm?.equipmentType === "INFRASTRUCTURE" && (
            <>
              <Box display={"flex"} mt="40px" flexWrap="wrap" gap="10px">
                <InputCreateProject
                  placeholder={"نام دارایی را وارد کنید"}
                  label="نام دارایی"
                  value={dataForm?.name}
                  onChange={(e) =>
                    setDataForm({ ...dataForm, name: e.target.value })
                  }
                />
                <InputCreateProject
                  placeholder={"شرکت سازنده تجهیزات را وارد کنید"}
                  label="شرکت سازنده"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, producer: e.target.value })
                  }
                  value={dataForm?.producer || ""}
                />
                <InputCreateProject
                  placeholder={"شماره اموال را وارد کنید"}
                  label="شماره اموال"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, propertyId: e.target.value })
                  }
                  value={dataForm?.propertyId || ""}
                />
                <InputCreateProject
                  placeholder={"تعداد تجیهزات را وارد کنید"}
                  label="تعداد تجهیزات"
                  onChange={(e) =>
                    setDataForm({
                      ...dataForm,
                      available: Number(e.target.value),
                    })
                  }
                  value={dataForm?.available || ""}
                  type="number"
                />
                <InputCreateProject
                  placeholder={"زمان خرید را وارد کنید"}
                  label="زمان خرید"
                  onClick={(e) => {
                    setShowDatePicker(e.currentTarget);
                  }}
                  value={date ? `${date.year}/${date.month}/${date.day} ` : ""}
                />
                <InputCreateProject
                  placeholder={"تاریخ اتمام گارانتی را وارد کنید."}
                  label="تاریخ اتمام گارانتی"
                  onClick={(e) => {
                    setShowDatePicker1(e.currentTarget);
                  }}
                  value={
                    date1 ? `${date1.year}/${date1.month}/${date1.day} ` : ""
                  }
                />

                <Box width={"250px"}>
                  <CustomizedHook
                    multiple
                    placeholder={"وضعیت را وارد کنید"}
                    label="وضعیت"
                    value={
                      [
                        { value: "سالم", key: "VALID" },
                        { value: "خراب", key: "DAMAGED" },
                        { value: "درحال تعمیر", key: "FIXING" },
                      ].find((w) => w.key === dataForm?.healthStatus) || null
                    }
                    options={[
                      { value: "سالم", key: "VALID" },
                      { value: "خراب", key: "DAMAGED" },
                      { value: "درحال تعمیر", key: "FIXING" },
                    ]}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setDataForm({
                          ...dataForm,
                          healthStatus: newValue.key,
                        });
                      }
                    }}
                  />
                </Box>

                <InputCreateProject
                  placeholder={"شماره ردیف را وارد کنید"}
                  label="شماره ردیف"
                  onChange={(e) =>
                    setDataForm({
                      ...dataForm,
                      rowNo: e.target.value,
                    })
                  }
                  value={dataForm?.rowNo || ""}
                  type="number"
                />
                <InputCreateProject
                  placeholder={"شماره قفسه تجهیزات را وارد کنید"}
                  label="شماره قفسه"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, shelfNo: e.target.value })
                  }
                  value={dataForm?.shelfNo || ""}
                />
                <InputCreateProject
                  placeholder={"محل انبار را وارد کنید"}
                  label="محل انبار"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, location: e.target.value })
                  }
                  value={dataForm?.location || ""}
                />
                <InputCreateProject
                  placeholder={"توضیحات را وارد کنید"}
                  label="توضیحات"
                  onChange={(e) =>
                    setDataForm({ ...dataForm, description: e.target.value })
                  }
                  value={dataForm?.description || ""}
                />
              </Box>
              <Box mt="20px" gap="10px" display={"flex"}>
                <button
                  style={{
                    border: "none",
                    color: "white",
                    background: "#125383",
                    width: "100px",
                    padding: "10px 0px",
                    borderRadius: "10px",
                  }}
                  onClick={() => {
                    // dataTable.push("mmd");
                    setDataTable([dataForm]);
                    // setDataForm({
                    //   name: "",
                    //   producer: "",
                    //   expireAt: "",
                    //   location: "SMALL",
                    //   drugType: "TAB",
                    //   available: "",
                    //   availablePack: "",
                    //   price: "",
                    //   shelfNo: "",
                    //   boxNo: "",
                    //   dose: "",
                    // });
                  }}
                >
                  ذخیره تجهیز
                </button>
                <button
                  style={{
                    border: "none",
                    color: "white",
                    background: "#126E83",
                    width: "100px",
                    padding: "10px 0px",
                    borderRadius: "10px",
                  }}
                  onClick={() => {
                    if (dataTable.length === 1) {
                      if (equipmentIdFromUpdate) {
                        updateEquipment(dataTable[0]?.id, dataTable[0])
                          .then(() => {
                            setMode("table");
                          })
                          .catch(() => {});
                      } else {
                        addOneEquipment(dataTable[0])
                          .then(() => {
                            setMode("table");
                          })
                          .catch(() => {});
                      }
                    }
                  }}
                >
                  ثبت تجهیز
                </button>
              </Box>
              <Box mt="30px">
                {dataTable?.length > 0 && (
                  <TableEquipment
                    date1={date1}
                    create
                    date={date}
                    rowData={dataTable}
                  />
                )}
              </Box>
            </>
          )}
        </Box>
      )}

      {selectType === 1 && (
        <Box>
          <Uploader setMode={setMode} equipment />
        </Box>
      )}
    </Box>
  );
}
